<template>
  <v-list-group no-action>
    <template v-slot:activator>
      <v-list-item-content color="primary">
        <v-list-item-title>{{ $t('common.' + language.id) }}</v-list-item-title>
      </v-list-item-content>
    </template>
    <v-list-item-group sub-group>
      <MainMenuSubCategory
        v-for="subcategory of subcategories"
        :key="subcategory.id"
        :subcategory="subcategory"
        :categoryId="categoryId"
        :languageCode="language.id"
      />
    </v-list-item-group>
  </v-list-group>
</template>

<script>
import MainMenuSubCategory from '@/components/MainMenuSubCategory'

export default {
  components: { MainMenuSubCategory },
  props: {
    language: Object,
    subcategories: Object,
    categoryId: String
  }
}
</script>
